import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
  extraRule:{}, //缓存规格
  kouStore:{}, //抠图信息缓存
  ruleColor:{}, //外加规格对应的颜色存储
  grouplist:[],
  platformInfo: {
    skin: 'skin1' //TODO：写这个是为了让h5页面先正常显示图片或样式，后期可以删除
  }, // 统一用
  userId: null, // 统一用
  printInfo: {
    printNumber: 0,//张数，一版几张
  }, // 统一用
  openId: 4, // 测试随便写的数据后期不用了
  specInfo: null,
  orderInfo: null,
  processedPhoto: {
    backcolor: [{
      start_color: '',
      enc_color: '',
      s_color: '',
      e_color: '',
      color_name: ''
    }],
    print: false,
    specId: 0,
    specName: '',
    picinfo: {
      algo_fileuuid: '',
      algo_fileuuid_no: '',
      algo_fileuuid_origin: '',
      ori_file_name: '',
      wm_url: [],
      wm_url_no: [],
      wm_url_beauty: [],
      algo_fileuuid_beauty: []
    }
  },
  bgColor: 0,
  searchResults: null,
  lastSearchWord: null,
  hotSearch: null,
  serviceTelNumber: null,
  consigneeInfo: null,
  price: null,
  printPrice: null,
  printPhotoQty: 1,
  isLoading: false,
  pageStack:[],//充当页面栈
  actiBol:true,//判断当前页面是push进来的还是返回的来的
  skintheme:{
    skin1:'four',
    skin2:'two',
    skin3:'six',
    skin4:'five',
    skin5:'seven',
    skin6:'three',
    skin7:'one'
  },//皮肤与主题映射现在用在hot.vue和tutorial.vue
  extraInfo:{},
  printextra:{},
  extraAddState:'', //不同端采用不同方法（'formal-新版前端可改动正式版本','interim-前端不可改动的过渡板','no-无此功能'）
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
});